/* eslint-disable */
import React, { useEffect, Fragment } from 'react';
import { Paper, Box } from '@mui/material';
import { Downgraded, useState } from '@hookstate/core';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import UserListDialog from './userListDialog';
import EditParticipant from './editParticipant';
import ConfirmationDialog from '../../../sharedcomponents/confirmationdialog/confirmationDialog';
import ApiHelper from '../../../utility/ApiHelper';
import Helper from '../../../utility/helper';
import { useAuthState } from '../../../stores/authStore';
import DataList from './dataList';
import { FULL_PERMISSION, VIEW_PERMISSION } from '../../../constants/Constant';
import EditAllParticipant from './editAllParticipant';
import APIURLConstants from '../../../config/config';
import RouteConstants from '../../../constants/routeConstants';
import CustomizedSnackbars from '../../../sharedcomponents/snackbar/snackBar';
import Title from '../../../sharedcomponents/title/title';
//import PdfApp from '../pdfCircuit';
import {
    pdf,
    Document,
    Page,
    Text,
    View,
    Line,
    Image,
    StyleSheet,
    Svg,
} from '@react-pdf/renderer';
import { useThemeState } from '../../../hookState/ThemeState';
import DefaultEvent from '../../../assets/images/default_event.jpg';
import Logo from '../../../assets/images/logo.png';
import Done from '../../../assets/images/done.png';
import Exclamtion from '../../../assets/images/exlamation.png';


const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
    cardContent: {
        '&:last-child': {
            paddingBottom: '16px',
        },
    },
}));
const styles = StyleSheet.create({
    page: {
        display: 'flex',
        // backgroundColor: '#E4E4E4',
    },
    section: {
        margin: 10,
        padding: 10,
        // flexGrow: 1,
    },
    rowView: {
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid #EEE',
        paddingTop: 6,
        paddingBottom: 6,
        textAlign: 'center',
        fontSize: '13px',
    },
});
const DocumentPdf = (props) => (
    <Document>
        <Page size="A4" style={styles.page}>
            <View
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: 10,
                    width: '100%',
                }}>
                <Text
                    style={{
                        fontSize: '18px',
                        color: '#3c5c93',
                        fontWeight: '600',
                        textAlign: 'center',
                    }}>
                    Player Media Circuit Schedule
                </Text>
                <Svg height="3" width="100%">
                    <Line
                        x1="0"
                        y1="0"
                        x2="600"
                        y2="0"
                        strokeWidth={5}
                        stroke="rgb(179,169,169)"
                    />
                </Svg>
                <View
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        height: props.playerDate ? '120px' : '110px',
                    }}>
                    <View style={{ padding: 10, width: '30%' }}>
                        <View
                            style={{
                                display: 'flex',
                                alignContent: 'center',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: props.playerDate ? '110px' : '90px',
                            }}>
                            <Image
                                src={props && props.url}
                                alt="logo"
                                style={{
                                    display: 'flex',
                                    alignContent: 'center',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    paddingTop: '5px',
                                    // width: '140px',
                                    paddingLeft: '16px',
                                }}
                            />
                        </View>
                    </View>
                    <View style={{ padding: 10, width: '70%' }}>
                        <View
                            style={{
                                padding: 10,
                                display: 'flex',
                                flexDirection: 'row',
                            }}>
                            <Text
                                style={{
                                    color: '#3c5c93',
                                    fontWeight: '600',
                                    fontSize: '16px',
                                    width: '30%',
                                }}>
                                Player Name
                            </Text>
                            <Text
                                style={{
                                    color: 'black',
                                    fontWeight: '600',
                                    fontSize: '16px',
                                    width: '50%',
                                }}>
                                {props.name}
                            </Text>
                        </View>

                        {props.playerDate && (
                            <View
                                style={{
                                    padding: 10,
                                    display: 'flex',
                                    flexDirection: 'row',
                                }}>
                                <Text
                                    style={{
                                        color: '#3c5c93',
                                        fontWeight: '600',
                                        fontSize: '16px',
                                        width: '30%',
                                    }}>
                                    {'Date & Time'}
                                </Text>
                                <Text
                                    style={{
                                        color: 'black',
                                        fontWeight: '600',
                                        fontSize: '16px',
                                        width: '50%',
                                    }}>
                                    {!Helper.IfDateIsNULL(props.playerDate)
                                        ? Helper.FormatDate(props.playerDate) +
                                        ' ' +
                                        Helper.FormatTime(props.playerDate)
                                        : ''}
                                </Text>
                            </View>
                        )}

                        <View
                            style={{
                                padding: 10,
                                display: 'flex',
                                flexDirection: 'row',
                            }}>
                            <Text
                                style={{
                                    color: '#3c5c93',
                                    fontWeight: '600',
                                    fontSize: '16px',
                                    width: '30%',
                                }}>
                                Location
                            </Text>

                            <Text
                                style={{
                                    color: 'black',
                                    fontWeight: '600',
                                    fontSize: '16px',
                                    width: '50%',
                                }}>
                                {Helper.getStorage('eventInfo').location}
                            </Text>
                        </View>
                    </View>
                </View>
                <Svg height="5" width="100%">
                    <Line
                        x1="0"
                        y1="0"
                        x2="600"
                        y2="0"
                        strokeWidth={5}
                        stroke="rgb(179,169,169)"
                    />
                </Svg>
                <View
                    style={{
                        padding: 7,
                        display: 'flex',
                        // flexDirection: 'column',
                        // fontSize: '15px',
                    }}>
                    <Fragment>
                        <View
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                padding:'4px',
                                textAlign: 'center',
                                fontSize: '13px', 
                            }}>
                            <Text 
                                style={{
                                    padding:'4px', 
                                    width:'8%'
                                }}
                            > 
                                    <Image
                                        src={Exclamtion}
                                        alt="warning"
                                        style={{
                                            display: 'flex',
                                            alignContent: 'center',
                                            justifyContent: 'center',
                                            alignItems: 'center', 
                                            width:'30px',
                                            height:'30px', 
                                        }}
                                    /> 
                            </Text>
                            <Text
                                style={{                                    
                                    color: 'red',
                                    fontWeight:'bold',
                                    border: '1px solid red',
                                    borderRadius: '5px',
                                    backgroundColor:'#ff00001f', 
                                    padding:'4px',
                                    overflow: 'hidden',
                                    width:'92%'
                                }}>
                                 {props.descText}
                            </Text>
                        </View>
                    </Fragment>
                </View> 
                <View
                    style={{
                        padding: 10,
                        display: 'flex',
                        // flexDirection: 'column',
                        // fontSize: '15px',
                    }}>
                    <Fragment>
                        <View
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                borderTop: '1px solid #EEE',
                                paddingTop: 4,
                                paddingBottom: 6,
                                textAlign: 'center',
                                fontSize: '13px',
                                backgroundColor: '#1D4289',
                            }}>
                            <Text
                                style={{
                                    width:
                                        !props.playerDate && props.timeFlag
                                            ? '25%'
                                            : '33%',
                                    backgroundColor: '#1D4289',
                                    color: 'white',
                                }}>
                                Event
                            </Text>
                            <Text
                                style={{
                                    width:
                                        !props.playerDate && props.timeFlag
                                            ? '25%'
                                            : '33%',
                                    backgroundColor: '#1D4289',
                                    color: 'white',
                                }}>
                                Room
                            </Text>

                            {!props.playerDate && props.timeFlag && (
                                <Text
                                    style={{
                                        width:
                                            !props.playerDate && props.timeFlag
                                                ? '25%'
                                                : '33%',
                                        backgroundColor: '#1D4289',
                                        color: 'white',
                                    }}>
                                    {'Activity Date  & Time'}
                                </Text>
                            )}
                            <Text
                                style={{
                                    width:
                                        !props.playerDate && props.timeFlag
                                            ? '25%'
                                            : '33%',
                                    backgroundColor: '#1D4289',
                                    color: 'white',
                                }}>
                                Complete
                            </Text>
                        </View>
                        {props.details.locations &&
                            props.details.locations.length > 0 && (
                                <>
                                    <View>
                                        {props.details.locations.map(
                                            (row, index) => (
                                                <View
                                                    style={styles.rowView}
                                                    key={index}>
                                                    <Text
                                                        style={{
                                                            width:
                                                                !props.playerDate &&
                                                                    props.timeFlag
                                                                    ? '25%'
                                                                    : '33%',
                                                        }}>
                                                        {row.name}
                                                    </Text>
                                                    <Text
                                                        style={{
                                                            width:
                                                                !props.playerDate &&
                                                                    props.timeFlag
                                                                    ? '25%'
                                                                    : '33%',
                                                        }}>
                                                        {row.location}
                                                    </Text>
                                                    {!props.playerDate &&
                                                        props.timeFlag && (
                                                            <Text
                                                                style={{
                                                                    width:
                                                                        !props.playerDate &&
                                                                            props.timeFlag
                                                                            ? '25%'
                                                                            : '33%',
                                                                }}>
                                                                {row.scheduleDateTime
                                                                    ? !Helper.IfDateIsNULL(
                                                                        row.scheduleDateTime
                                                                    )
                                                                        ? Helper.FormatDate(
                                                                            row.scheduleDateTime
                                                                        ) +
                                                                        ' ' +
                                                                        Helper.FormatTime(
                                                                            row.scheduleDateTime
                                                                        )
                                                                        : ''
                                                                    : ''}
                                                            </Text>
                                                        )}

                                                    <Text
                                                        style={{
                                                            width:
                                                                !props.playerDate &&
                                                                    props.timeFlag
                                                                    ? '25%'
                                                                    : '33%',
                                                        }}>
                                                        {row.completed ? (
                                                            <Image
                                                                src={Done}
                                                                alt="donelogo"
                                                                style={{
                                                                    display:
                                                                        'flex',
                                                                    alignContent:
                                                                        'center',
                                                                    justifyContent:
                                                                        'center',
                                                                    alignItems:
                                                                        'center',
                                                                    paddingTop:
                                                                        '5px',
                                                                    // width: '140px',
                                                                    paddingLeft:
                                                                        '16px',
                                                                }}
                                                            />
                                                        ) : (
                                                            ''
                                                        )}
                                                    </Text>
                                                </View>
                                            )
                                        )}
                                    </View>
                                </>
                            )}
                    </Fragment>
                </View>
            </View>
        </Page>
    </Document>
);

const SetTiming = () => {
    const classes = useStyles();
    const setAll = useState(false);
    const users = useState([]);
    const allParticipants = useState([]);
    const openDialog = useState(false);
    const openUserDialog = useState(false);
    const openUserEditAllDialog = useState(false);
    // const syncParticipantsInfo = useState(null);
    const eventUserInfo = useState(null);
    const authState = useAuthState();
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [descText, setDescText] = React.useState('');

    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });

    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });
    const [modPermission, setModPermission] = React.useState(null);
    const loading = useState(false);
    const editSelectedParticipant = useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    // const [listData, setListData] = React.useState([]);
    const [filterListData, setFilterListData] = React.useState([]);
    const themeState = useThemeState();
    let url = !themeState.eventEnabled.value
        ? Logo
        : themeState.eventImageUrl.value != ''
            ? themeState.eventImageUrl.value
            : DefaultEvent;

    useEffect(() => {
        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        ) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);
    const getModuleConfig = () => {
        const ModuleID = 15;
        const type = "MediaCircuitText";

        ApiHelper.get(APIURLConstants.GET_MODULE_CONFIG(ModuleID, type))
            .then((res) => {
                // console.log(res.data);
                let data = res.data;
                if (data) {
                    // console.log(data);
                    setDescText(data && data[0].value)
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }
    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (
            Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) ||
            (userInfo.roles && Helper.isEventStaff(userInfo))
        ) {
            setModPermission(FULL_PERMISSION);
        } else {
            setModPermission(VIEW_PERMISSION);
        }
        getParticipants();
        getModuleConfig()
    }, []);

    // const getAllParticipants = () => {
    //     const gEventInfo = Helper.getStorage('eventInfo');
    //     ApiHelper.get(
    //         APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
    //     ).then((res) => {
    //         if (res.data.rows) {
    //             allParticipants.set(res.data.rows);
    //         }
    //     });
    // };

    const getParticipants = () => {
        const eventInfo = Helper.getStorage('eventInfo');
        if (eventInfo) {
            loading.set(true);
            ApiHelper.get(
                APIURLConstants.GET_MEDIA_CIRCUIT_PARTICIPANT(
                    eventInfo.eventID,
                    0
                )
            )
                .then((res) => {
                    loading.set(false);
                    console.log(res.data);
                    if (res.data) {
                        let usersData = [];
                        if (res.data.rows.length > 0) {
                            res.data.rows.map((item) => {
                                let locationText = getText(item.locations);

                                usersData.push({
                                    actualData: item,
                                    row: [
                                        {
                                            label: 'checkbox',
                                            key: 'eventUsersID',
                                            eventUsersID: item.userID,
                                            width: '0.1',
                                        },
                                        {
                                            label: 'Name',
                                            key: 'name',
                                            name: item.participant,
                                            showLabel: false,
                                            width: '0.3',
                                            inColumn: true,
                                            toEmail: item.email,
                                            showEmail: true,
                                        },
                                        {
                                            label: 'Role',
                                            key: 'roleName',
                                            roleName: item.roleName,
                                            width: '0.3',
                                            showLabel: true,
                                            wrapUp: true,
                                        },
                                        {
                                            label: 'Tags',
                                            key: 'tags',
                                            tags: item.userTags,
                                            showChips: true,
                                            width: '0.1',
                                            showLabel: true,
                                            wrapUp: true,
                                        },
                                        {
                                            label: 'Tags',
                                            key: 'tags',
                                            tags: '',
                                            width: '0.1',
                                        },
                                        {
                                            label: 'Location',
                                            key: 'location',
                                            location: locationText,
                                            width: '0.6',
                                            showLabel: false,
                                            // wrapUp: true,
                                        },

                                        {
                                            label: 'Date & Time',
                                            key: 'playerDate',
                                            playerDate:
                                                item.locations[0] &&
                                                    item.locations[0].playerDate
                                                    ? Helper.FormatDate(
                                                        item.locations[0] &&
                                                        item.locations[0]
                                                            .playerDate
                                                    ) +
                                                    ' ' +
                                                    Helper.FormatTime(
                                                        item.locations[0] &&
                                                        item.locations[0]
                                                            .playerDate
                                                    )
                                                    : null,
                                            width: '0.3',
                                            showLabel: true,
                                            wrapUp: true,
                                        },

                                        // {
                                        //     label: 'scheduleDateTime',
                                        //     key: 'scheduleDateTime',
                                        //     scheduleDateTime: !Helper.IfDateIsNULL(
                                        //         item.scheduleDateTime
                                        //     )
                                        //         ? Helper.FormatDate(
                                        //             item.scheduleDateTime
                                        //         ) +
                                        //         ' ' +
                                        //         Helper.FormatTime(
                                        //             item.scheduleDateTime
                                        //         )
                                        //         : '',
                                        //     width: '0.3',
                                        //     showLabel: false,
                                        //     wrapUp: true,
                                        // },
                                        {
                                            label: 'Action',
                                            key: 'edit',
                                            edit: 'Edit',
                                            width: '0.1',
                                        },
                                    ],
                                    selected: false,
                                    CustomSelected: true,
                                });
                            });
                        }
                        // setListData(usersData);
                        setFilterListData(usersData);
                        users.set(usersData);
                        if (pagingInfo.get().noOfPages == null) {
                            pagingInfo.set({
                                ...pagingInfo,
                                currentPage: pagingInfo.get().currentPage,
                                itemsPerPage: pagingInfo.get().itemsPerPage,
                                noOfPages: Math.ceil(
                                    res.data.totalCount /
                                    pagingInfo.get().itemsPerPage
                                ),
                            });
                        }
                    }
                })
                .catch((err) => {
                    loading.set(false);
                    //... Check if user's session has expired
                    if (err.response && err.response.status === 401) {
                        console.log(err);
                    }
                });
        }
    };
    // console.log('user', users.get());
    const getText = (array) => {
        let text = [];

        array && array.length > 0
            ? array.map((vals) => {
                text.push(
                    vals.name +
                    ' (' +
                    vals.location +
                    ')' +
                    (vals.scheduleDateTime === '0001-01-01T00:00:00'
                        ? ' '
                        : ' - ' +
                        Helper.FormatDateTime(vals.scheduleDateTime)) +
                    ';'
                );
            })
            : '';

        return text.toString();
    };
    const redirectToCreate = () => {
        openDialog.set(true);
    };

    const handleClose = () => {
        openDialog.set(false);
    };

    const editUser = (userInfo) => {
        eventUserInfo.set(userInfo.actualData);
        openUserDialog.set(true);
    };

    const editAll = () => {
        const selected = users.get().filter((user) => user.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select  participants first',
            });
        } else {
            editSelectedParticipant.set();
            editSelectedParticipant.set(selected);
            openUserEditAllDialog.set(true);
        }
    };

    const closeEditUser = () => {
        eventUserInfo.set(null);
        openUserDialog.set(false);
    };

    const closeEditAllUser = () => {
        editSelectedParticipant.set(null);
        openUserEditAllDialog.set(false);
    };

    const onCustomCheckSelect = (event, item) => {
        let newUsers = users.attach(Downgraded).get();
        // newUsers[index]['CustomSelected'] = event.target.checked;
        let index = newUsers.findIndex(
            (x) => x.actualData.eventUsersID === item.actualData.eventUsersID
        );
        newUsers[index]['CustomSelected'] = event.target.checked;
        let rowProps = newUsers[index]['row'];
        let rowPropIndex = rowProps.findIndex((x) => x.key == 'skip_email');

        newUsers[index]['row'][rowPropIndex].excludeEmail =
            event.target.checked == true ? 1 : 0;
        users.set(newUsers);
        const gEventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');

        let requestObj = {
            eventID: gEventInfo.eventID,
            userID: userInfo.userID,
            eventUsersID: item.actualData.eventUsersID,
            excludeEmail: event.target.checked == true ? 1 : 0,
        };

        ApiHelper.post(APIURLConstants.Update_Excluded_Email, requestObj).then(
            (res) => {
                if (res.data) {
                    getParticipants();
                    // getAllParticipants();
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Participant Updated Successfully',
                    });
                }
            }
        );
    };

    const deleteParticipants = () => {
        const selected = users.get().filter((user) => user.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants first',
            });
        } else {
            let message =
                selected.length == users.get().length
                    ? 'Do you want to delete all participants Timings ?'
                    : 'Do you want to delete selected participant Timing?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };

    const callExport = () => {
        const selected = users.get().filter((user) => user.selected === true);
        const allSelected = users
            .get()
            .filter((user) => user.selected === false);
        if (selected.length === 0) {
            generateExcelReport(allSelected);
        } else {
            generateExcelReport(selected);
        }
    };
    const generateExcelReport = async (result) => {
        let selectedIds = [];
        let IDs = null;
        if (result.length > 0) {
            result.map((item) => {
                selectedIds.push(item.actualData.eventUsersID);
            });
            IDs = selectedIds.join(',');
        }
        const gEventInfo = Helper.getStorage('eventInfo');

        await ApiHelper.post(
            APIURLConstants.POST_ParticipantExport,{EventID:gEventInfo.eventID, UserIDs:IDs}
        ).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            if (finalObject) {
                if (finalObject.length > 0) {
                    let header = {};
                    Object.keys(finalObject[0]).map((key) => {
                        header[key] = key;
                    });

                    finalObject.unshift(header);
                    Helper.downloadReport(finalObject, `Participant-Report`);
                }
            }
        });
    };
    const delay = (t) => new Promise((resolve) => setTimeout(resolve, t));

    const callPdfExport = async () => {
        const selected = users
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants first',
            });
            return;
        }
        let count = 0
        selected &&
            selected.length > 0 &&
            selected.map(async (key) => {
                let timeFlag = false;
                key.actualData.locations &&
                    key.actualData.locations.length > 0 &&
                    key.actualData.locations.map((loc) => {
                        if (loc.scheduleDateTime) {
                            timeFlag = true;
                        }
                    });
                const props = {
                    details: key.actualData,
                    playerDate: key.actualData.locations[0].playerDate,
                    url: url,
                    timeFlag: timeFlag,
                    name: key.actualData.participant,
                    descText:descText
                };

                const doc = <DocumentPdf {...props} />;
                const asPdf = pdf([]); // {} is important, throws without an argument
                asPdf.updateContainer(doc);
                await delay(1500);
                const blob = await asPdf.toBlob();
                const link = document.createElement("a");
                const file = new Blob([blob], { type: 'application/pdf' });
                link.href = URL.createObjectURL(file);

                link.download = key.actualData.participant + '.pdf';
                link.click();
                URL.revokeObjectURL(link.href);
                if (count > 4) {
                    sleep(1000);
                    count = 0;
                } else {
                    count = count + 1;
                }

            });
    };
    function sleep(milliseconds) {
        let timeStart = new Date().getTime();
        while (1) {
            let elapsedTime = new Date().getTime() - timeStart;
            if (elapsedTime > milliseconds) {
                break;
            }
        }
    }

    const handleConfirmation = () => {
        const userInfoValue = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');
        let deletUsersID = [];
        users.get().map((user) => {
            if (user.selected === true) {
                deletUsersID.push(user.actualData.userID);
            }
        });

        ApiHelper.post(APIURLConstants.SET_USER_MEDIA_CIRCUIT_TIME, {
            userIDs: deletUsersID.toString(),
            eventID: eventInfo.eventID,
            modifiedBy: userInfoValue.userID,
            mediaCircuitLocationTime: [
                {
                    eventID: eventInfo.eventID,
                    mediaCircuitID: 0,
                    scheduleDateTime: new Date(),
                },
            ],
            DeleteFlag: true,
        })
            .then((res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Timings deleted successfully',
                    });
                    // deleteNotificationParticiapant(deletUsersID.join(','), userInfoValue.userID)
                    setShowSearchRec(false);
                    getParticipants();
                    // getAllParticipants();
                    setTimeout(() => {
                        setAll.set(false);
                    }, 300);
                }
            })
            .catch((error) => {
                console.log('error : ', error);
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting participants';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const handleOnChange = (str) => {
        // let str = event.target.value;
        // setFilterListData([]);
        const value = str.replace(/^\s+/g, '');
        // setSearch(value);
        if (value.length > 0) {
            let modifyList = [];
            users
                .attach(Downgraded)
                .get()
                .forEach((item) => {
                    let data = item.actualData;
                    let keys = Object.keys(data);

                    keys.forEach((key) => {
                        if (
                            typeof data[key] === 'string' &&
                            data[key]
                                .toLowerCase()
                                .indexOf(value.toLowerCase()) > -1
                        ) {
                            if (modifyList.indexOf(item) == -1)
                                modifyList.push(item);
                        }
                    });
                });
            setFilterListData(modifyList);
        } else {
            setFilterListData([]);
            setFilterListData(users.attach(Downgraded).get());
        }
    };
    // console.log(search);
    // console.log(filterListData);
    return (
        <>
            {loading.get() ? (
                <Box
                    sx={
                        loading.get()
                            ? { paddingTop: '20%', paddingBottom: '20%' }
                            : ''
                    }
                    className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box
                    className="contentBox">
                    <Box>
                        {/* <PdfApp /> */}
                        {filterListData && filterListData ? (
                            <>
                                <Title title="Set Activity Time"></Title>
                                <DataList
                                    data={filterListData}
                                    // data={users.attach(Downgraded).get()}
                                    onCustomCheckSelect={onCustomCheckSelect}
                                    editRow={editUser}
                                    handleClick={redirectToCreate}
                                    buttonTitle={'Add'}
                                    showEdit={false}
                                    hideAdd={true}
                                    deleteRows={deleteParticipants}
                                    showSearch={true}
                                    showSelectAll={
                                        filterListData && filterListData > 0
                                            ? true
                                            : false
                                    }
                                    searchLabel={'Search'}
                                    title={''}
                                    callExport={callExport}
                                    showSearchRec={showSearchRec}
                                    setShowSearchRec={setShowSearchRec}
                                    // deleteConnection={onDeleteConnection}
                                    modPermission={modPermission}
                                    editAll={editAll}
                                    isParticipantFilter={true}
                                    handleOnChange={handleOnChange}
                                    callPdfExport={callPdfExport}
                                />
                            </>
                        ) : null}
                        {openDialog.get() && (
                            <UserListDialog
                                open={openDialog.get()}
                                title="Add Participant Timing"
                                handleClose={handleClose}
                                users={users.attach(Downgraded).get()}
                                snackBarProps={snackBarProps}
                                setSnackBarProps={setSnackBarProps}
                                getParticipants={getParticipants}
                                // getAllParticipants={getAllParticipants}
                                eventParticipants={
                                    allParticipants.get().length > 0
                                        ? allParticipants.attach(Downgraded).get()
                                        : []
                                }
                            />
                        )}

                        {openUserDialog.get() && (
                            <EditParticipant
                                open={openUserDialog.get()}
                                eventUserInfo={eventUserInfo
                                    .attach(Downgraded)
                                    .get()}
                                title="Edit Activity Timing"
                                handleClose={closeEditUser}
                                snackBarProps={snackBarProps}
                                setSnackBarProps={setSnackBarProps}
                                getParticipants={getParticipants}
                            />
                        )}
                        {openUserEditAllDialog.get() && (
                            <EditAllParticipant
                                open={openUserEditAllDialog.get()}
                                eventUserInfo={editSelectedParticipant
                                    .attach(Downgraded)
                                    .get()}
                                title="Edit Activity Timings"
                                handleClose={closeEditAllUser}
                                snackBarProps={snackBarProps}
                                setSnackBarProps={setSnackBarProps}
                                getParticipants={getParticipants}
                            />
                        )}

                        {
                            <ConfirmationDialog
                                open={deleteConfirmation.get().open}
                                message={deleteConfirmation.get().message}
                                OkButtonText={deleteConfirmation.get().OkButtonText}
                                handleCnfClick={() =>
                                    handleConfirmation(deleteConfirmation)
                                }
                                onCancelClick={() => {
                                    deleteConfirmation.set({
                                        ...deleteConfirmation.get(),
                                        open: false,
                                    });
                                }}></ConfirmationDialog>
                        }
                    </Box>
                </Box>
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: false,
                        })
                    }></CustomizedSnackbars>
            )}
        </>
    );
};
export default {
    routeProps: {
        path: RouteConstants.SET_TIMINGS,
        component: SetTiming,
    },
    name: 'SetTiming',
};
